"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useReactlytics2 = _interopRequireDefault(require("./useReactlytics"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useReactlyticsHandler = function useReactlyticsHandler() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var handlerNameSet = arguments.length > 1 ? arguments[1] : undefined;

  var _useReactlytics = (0, _useReactlytics2.default)(),
      track = _useReactlytics.track,
      handlerCreators = _useReactlytics.handlerCreators,
      _useReactlytics$shoul = _useReactlytics.shouldExtendHandler,
      shouldExtendHandler = _useReactlytics$shoul === void 0 ? function () {
    return true;
  } : _useReactlytics$shoul;

  if (handlerCreators) {
    var defaultHandler = handlerCreators.default,
        otherHandlers = _objectWithoutProperties(handlerCreators, ["default"]);

    var handlerList = handlerNameSet || Object.keys(otherHandlers);
    var extendedHandlers = handlerList.reduce(function (map, propName) {
      if (shouldExtendHandler(propName, props[propName])) {
        var createHandler = handlerCreators[propName] || defaultHandler;

        if (!createHandler) {
          // eslint-disable-next-line no-console
          console.warn("Failed to extend ".concat(propName, ", as a handlerCreator or default was not found"));
          return _objectSpread({}, map, _defineProperty({}, propName, props[propName]));
        }

        var originalHandler = props[propName] || function () {
          return 0;
        };

        var trackHandler = createHandler(track, function () {}, props);

        var newHandler = function newHandler() {
          trackHandler.apply(void 0, arguments);
          originalHandler.apply(void 0, arguments);
        };

        return _objectSpread({}, map, _defineProperty({}, propName, newHandler));
      }

      return map;
    }, {}); // The reactlytics props is removed to prevent additional props from being passed
    // to the wrapped component, in the event they spread the returning props onto a DOM element.
    // This helps avoid weird data attributes being attached to the DOM element
    // if extra props are added to support reactlytics

    return _objectSpread({}, props, {}, extendedHandlers, {
      reactlytics: undefined
    });
  }

  return _objectSpread({}, props, {
    reactlytics: undefined
  });
};

var _default = useReactlyticsHandler;
exports.default = _default;